export default "__VITE_ASSET__Dsv935cu__"